import { Component, OnInit } from "@angular/core";
import { FillLevels }        from "../../../../shared-gen/Model/Selections/FillLevels";
import { AppStatusService }  from "../../../services/app-status.service";
import { MachineApi }        from "../../../services/api/machine-api.service";
import { AppStatus }         from "../../../@models/app-status";
import { StatusListener }    from "../../../status-listener";
import { AppService }        from "../../../services/app.service";
import { SelectionsRow }     from "../../../../shared-gen/Model/Selections/SelectionsRow";

@Component({
	selector: "app-tur-filling-panel",
	templateUrl: "./tur-filling-panel.component.html",
	styleUrls: ["./tur-filling-panel.component.scss"]
})
export class TurFillingPanelComponent extends StatusListener implements OnInit {

	machines = [];


	fillLevelStatus = {
		low: 3,
		medium: 6
	};

	deviceFillLevels;
	deviceSelections;

	constructor(private appStatusService: AppStatusService, private machineApi: MachineApi, app: AppService) {
		super(app);
	}

	onStatusChanged(status: AppStatus) {
		super.onStatusChanged(status);
		const device = status.deviceStatus;

		this.deviceFillLevels = device.MachineStatus.FillLevels;
		this.deviceSelections = status.selections;

		this.setUpMachineList();
	}

	setUpMachineList() {
		let _machines = [];
		for (let i = 0; i < this.deviceSelections.Machines.length; i++) {
			let _machine = {
				"Rows": []
			};
			for (let j = 0; j < this.deviceSelections.Machines[i].Rows.length; j++) {
				let _row = {
					"Columns": []
				};
				for (let k = 0; k < this.deviceSelections.Machines[i].Rows[j].Columns.length; k++) {
					let _column;
					//Prevent overwritting of edited Products
					if (this.machines.length > 0 && this.machines[i].Rows[j].Columns[k].Edited) {
						_column = this.machines[i].Rows[j].Columns[k];
					} else {
						_column = JSON.parse(JSON.stringify(this.deviceSelections.Machines[i].Rows[j].Columns[k]));
						_column.Edited = false;
						let remainingCount = this.getRemainingCount(_column.Number);
						_column.InitialRemainingCount = remainingCount;
						_column.RemainingCount = remainingCount;
					}

					_row.Columns.push(_column);
				}
				_machine.Rows.push(_row);
			}
			_machines.push(_machine);
		}

		this.machines = _machines;
	}


	resetChanges() {
		this.resetEditedStatus();
		this.setUpMachineList();
	}

	refillAll() {
		this.forAllMachines((i, j, k, rows) => this.setMaxQuantity(rows[j].Columns[k]));
	}

	setMaxQuantity(product) {
		product.RemainingCount = product.Capacity;
		this.setProductEdited(product);
	}

	addQuantity(product) {
		if (product.RemainingCount < product.Capacity) {
			product.RemainingCount += 1;
			this.setProductEdited(product);
		}
	}

	setProductEdited(product) {
		product.Edited = product.InitialRemainingCount != product.RemainingCount;
	}

	async saveFillingChanges() {
		let _deviceFillLevels = {
			"Selections": []
		} as FillLevels;
		this.forAllMachines((i, j, k, rows) => {
			let column: any = rows[j].Columns[k];
			_deviceFillLevels.Selections.push({
				"SelectionNumber": column.Number,
				"RemainingCount": column.RemainingCount
			});
		});
		await this.machineApi.setFillLevels(_deviceFillLevels);
		this.resetEditedStatus();
	}

	getRemainingCount(selectionNumber) {
		for (let i = 0; i < this.deviceFillLevels.Selections.length; i++) {
			if (this.deviceFillLevels.Selections[i].SelectionNumber == selectionNumber) {
				return this.deviceFillLevels.Selections[i].RemainingCount;
			}
		}
		return 0;
	}

	removeQuantity(product) {
		if (product.RemainingCount > 0) {
			product.RemainingCount -= 1;
			this.setProductEdited(product);
		}
	}

	resetEditedStatus() {
		this.forAllMachines((i, j, k) => this.machines[i].Rows[j].Columns[k].Edited = false);
	}

	forAllMachines(code: (i: number, j: number, k: number, rows: SelectionsRow[]) => unknown) {
		for (let i = 0; i < this.machines.length; i++) {
			let rows = this.machines[i].Rows;
			for (let j = 0; j < rows.length; j++)
				for (let k = 0; k < rows[j].Columns.length; k++)
					code(i, j, k, rows);
		}
	}
}
